export default __webpack_public_path__ + "static/media/place-small.ff050e02.jpg";